import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100vw",
      height: "100vh",
      padding: 24,
    },
    actionButton: {
      maxWidth: 300,
      marginTop: "10%",
      marginBottom: 25,
    },
    h1: {
      fontSize: 24,
      marginTop: "8%",
    },
    h2: {
      fontSize: 18,
    },
    logosContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: 150,
      padding: "25px 0",
    },
    logoContainer: {
      flex: 1,
      height: "100%",
      position: "relative",
    },
    vida: {
      position: "absolute",
      bottom: 0,
      left: "40%",
      width: 45,
      margin: 0,
      color: "#0088ff",
    },
    logo: {
      height: "100%",
      objectFit: "contain",
    },
    ghImage: {
      flex: 1,
      height: "100%",
      objectFit: "contain",
    },
  })
);
